import React from 'react';
import { Card, CardBody, CardHeader, Progress } from 'reactstrap';
import Icon from 'components/Icon';

interface LicenseStatusCardProps {
  total: number;
  active: number;
  inUse: number;
  available: number;
  isLoading?: boolean;
}

const LicenseStatusCard = ({
  total,
  active,
  inUse,
  available,
  isLoading = false
}: LicenseStatusCardProps) => {
  const activePercentage = total > 0 ? Math.round((active / total) * 100) : 0;
  const inUsePercentage = total > 0 ? Math.round((inUse / total) * 100) : 0;

  return (
    <Card className="border-0 shadow-sm h-100">
      <CardHeader className="bg-white border-0 pt-4 pb-2">
        <h5 className="mb-0 fw-bold">
          <Icon icon="key" className="me-2 text-primary" />
          Status das Licenças
        </h5>
      </CardHeader>
      <CardBody>
        <div className="mb-4">
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted small">Licenças Ativas</span>
            <span className="fw-bold text-success">
              {active}/{total} ({activePercentage}%)
            </span>
          </div>
          <Progress
            value={activePercentage}
            color="success"
            className="mb-0"
            style={{ height: '8px' }}
          />
        </div>

        <div className="mb-4">
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted small">Licenças em Uso</span>
            <span className="fw-bold text-primary">
              {inUse}/{total} ({inUsePercentage}%)
            </span>
          </div>
          <Progress
            value={inUsePercentage}
            color="primary"
            className="mb-0"
            style={{ height: '8px' }}
          />
        </div>

        <div className="row text-center mt-4">
          <div className="col-3">
            <div className="border rounded p-3">
              <h4 className="mb-0 fw-bold text-dark">{total}</h4>
              <small className="text-muted">Total</small>
            </div>
          </div>
          <div className="col-3">
            <div className="border rounded p-3">
              <h4 className="mb-0 fw-bold text-success">{active}</h4>
              <small className="text-muted">Ativas</small>
            </div>
          </div>
          <div className="col-3">
            <div className="border rounded p-3">
              <h4 className="mb-0 fw-bold text-primary">{inUse}</h4>
              <small className="text-muted">Em Uso</small>
            </div>
          </div>
          <div className="col-3">
            <div className="border rounded p-3">
              <h4 className="mb-0 fw-bold text-info">{available}</h4>
              <small className="text-muted">Disponíveis</small>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default LicenseStatusCard;
